import React from 'react'
import { daysBetween } from '../../utils/dateUtils'
import 'moment-range'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { openVisitDialog } from '../../redux/actions/dashboardActions'
import { Checkbox } from 'react-bootstrap'
import { selectVisit } from '../../redux/modules/roomTransferModule'

const DashboardPanel = props => {
  const { date, visit, roomTransfer } = props

  const handleOnVisitClick = visit => {
    if (visit.type !== 'blackout') {
      props.dispatch(openVisitDialog({ visitId: visit.id }))
      console.log(props)
    }
  }

  let numDays = daysBetween(visit.checkInDate, visit.checkOutDate)
  let isFromPreviousPeriod = false

  // If the check in date is before today, it's from the previous time period
  // And there is some special logic to make it draw nicely
  if (visit.checkInDate.isBefore(date, 'day')) {
    numDays = visit.checkOutDate.diff(date, 'days') + 1
    isFromPreviousPeriod = true
  }
  // Computes panel width so that it spans the number of days of the visit
  // 100% lines up to about the size of 1 day, so we multiply that
  // by the number of days.
  // I'm using 104 here because there seems to be some extra width for each day (like border)
  // that we need to account for
  let panelWidth = numDays * 104 + '%'
  // Sets panel vertical position
  // 0.26 is there for padding
  let panelBottom = visit.level * 3 + 0.26 + 'em'

  let panelClass = classNames(
    'dashboard-booking-panel',
    { 'dashboard-booking-previous-period': isFromPreviousPeriod },
    { 'checked-in': visit.checkedIn },
    { 'checked-out': visit.checkedOut },
    { blackout: visit.type === 'blackout' },
    {
      internalUse: visit.visitPurpose
        ? visit.visitPurpose.indexOf(
            'Attending Program at iii - internal use only'
          ) >= 0
        : false
    }
  )

  const panelText = visit.type !== 'blackout' ? visit.guest.name : 'Blackout'

  return (
    <div className='dashboard-booking-panel-wrapper' key={visit.id}>
      <div
        className={panelClass}
        style={{ width: panelWidth, bottom: panelBottom }}
        onClick={() =>
          roomTransfer
            ? roomTransfer.status !== 'active' && handleOnVisitClick(visit)
            : handleOnVisitClick(visit)
        }
      >
        <div
          className='dashboard-booking-panel-text-wrapper'
          style={{ display: 'flex' }}
        >
          {roomTransfer && roomTransfer.status === 'active' && (
            <div>
              <Checkbox
                style={{ margin: '0' }}
                onChange={() => {
                  props.dispatch(selectVisit(visit.id))
                }}
                checked={roomTransfer.selectedVisits.includes(visit.id)}
              />
            </div>
          )}
          {panelText}
        </div>
      </div>
    </div>
  )
}

// Wrap the component to inject dispatch and state into it
export default connect()(DashboardPanel)



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardPanel.js